import {
    Component, EventEmitter, OnDestroy, OnInit,
    Output
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {NGXLogger} from 'ngx-logger';
import {GroupService} from '../../../../../_services/group.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'acabim-admin-groups-project-add',
    templateUrl: './add-project-group.component.html'
})
export class GroupProjectAddComponent implements OnInit, OnDestroy {

    @Output() completed = new EventEmitter<string>();
    loading = false;
    projectGroupForm: FormGroup | undefined;
    private _currentProcess: Subscription = new Subscription();

    constructor(
        private readonly logger: NGXLogger,
        private groupService: GroupService
    ) {}

    ngOnInit(): void {
        this.projectGroupForm = new  FormGroup({
            projectGroupName: new FormControl()
        });
    }

    onProjectGroupAddSubmit(): void {
        console.log('Running Add onSubmit for Project Group');
        this.upsertProjectGroup();
    }

    private upsertProjectGroup(): void {
        this.loading = true;
        this.logger.debug('[GroupProjectAddComponent] Adding new project group');
        this._currentProcess = this.groupService.upsertProjectGroup(
            this.projectGroupForm?.value.projectGroupName
        ).subscribe(newProjectGroup => {
            this.logger.debug('[GroupProjectAddComponent] Project group added successfully: ', newProjectGroup.id);
            this.clearForm();
            this.completed.emit('added');
            this.loading = false;
            console.log('Upsert: added');
        }, (error: any) => {
            this.logger.debug('[GroupProjectAddComponent] Project group failed to add');
            this.logger.error(error);
            this.loading = false;
        });
    }

    onCancel(): void {
        this.logger.debug('[GroupProjectAddComponent] Add Project Group Modal Cancelled');
        console.log('Upsert: cancelling');
        this.completed.emit('cancelled');
    }

    clearForm(): void {
        this.projectGroupForm?.patchValue({
            projectGroupName: null
        });
    }

    ngOnDestroy(): void {
        this._currentProcess.unsubscribe();
    }
}
